import type { GoldMonthlyTitle } from "./types";
import { GridRewardCard } from "./components/GridRewardCard";
import { HorizontalRewardCard } from "./components/HorizontalRewardCard";

// Figma: https://www.figma.com/design/z9Ut4lxLJQZK28vEZiHRwN/Monthly-rewards?node-id=3-3390

export interface MonthlyRewardCardProps {
  titleData: GoldMonthlyTitle;
  isClaiming: boolean;
  isGold: boolean;
  layout?: "grid" | "horizontal";
  onClaim: () => void;
  onSubscribe: () => void;
}

export function MonthlyRewardCard(props: MonthlyRewardCardProps) {
  const { layout = "grid" } = props;
  if (layout === "horizontal") {
    return <HorizontalRewardCard {...props} />;
  }
  return <GridRewardCard {...props} />;
}
